module.exports = __webpack_public_path__ + "img/lianjie.bbb45a8d.png";